module.exports = __webpack_public_path__ + "static/img/advModel3.70f6ba19.png";